<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="directionOptions"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'dropdown-direction';
const DEFAULT_VALUE = 'down';

export default {
    name: 'control-nav-dropdown-direction',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Dropdown Direction',
            value: DEFAULT_VALUE,

            directionOptions: [
                { text: 'Down', value: 'down' },
                { text: 'Left', value: 'left' },
                { text: 'Right', value: 'right' },
            ],
        };
    },

    methods: {
        onInput(valueNew) {
            this.value = valueNew;
            this.selectedElements.forEach(elem => elem.setElementData(CUSTOM_ATTR_NAME, valueNew));
            this.onOptionChange(valueNew);
        },

        onSelectedElement() {
            this.value = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) || DEFAULT_VALUE;
        },
    },
};
</script>
